var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white",staticStyle:{"padding":"10px 7px"}},[_c('pageTable',{attrs:{"custCode":_vm.custCode}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }